<template>
  <div>
    <!-- <div id="loading-area" class="loading-page-1">
      <div class="loader">
        <img src="/assets/images/Explore2Teach.gif" alt="" />
      </div>
    </div> -->
    <!-- Video Background -->
    <div class="video-container">
      <video autoplay muted loop playsinline>
        <source src="assets/images/video_landing.mp4" type="video/mp4" />
      </video>
    </div>

    <!-- Jumbotron Section -->
    <div class="jumbotron-container">
      <div class="jumbotron text-center">
        <img
          src="assets/images/logo_stacked.png"
          class="img-fluid d-block mx-auto home_logo"
          alt=""
        />
        <h1 class="display-4 text-white text-shadow">
          {{pageContent.header_title}}<br />{{pageContent.header_title_br}}
        </h1>
        <p class="lead text-shadow text-white">
          {{pageContent.header_description}}<br />{{pageContent.header_description_br}}
        </p>
        <a
          class="btn btn-primary btn-xl mt-2 py-4"
          href="#"
          role="button"
          @click="scrollToSubscription"
        >
        {{pageContent.header_button}}   
           </a>
      </div>
    </div>

    <div class="page-content">
      <section class="signup mb-0 bg-light" ref="subscriptionSection">
        <div class="container">
          <div class="signup-content">
            <div class="signup-form">
              <h2 class="form-title mb-0">{{pageContent.form_title}}   </h2>

              <form @submit.prevent="subscribeUser" class="mt-2">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group mb-4">
                      <label class="form-label" for="username"
                        >{{pageContent.form_first_name}}</label
                      >
                      <input
                        type="text"
                        v-model="firstName"
                        class="form-control"
                        :placeholder="form_first_name_placeholder"
                        id="first_name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group mb-4">
                      <label class="form-label" for="username">{{pageContent.form_last_name}}</label>
                      <input
                        type="text"
                        v-model="lastName"
                        class="form-control"
                        :placeholder="form_last_name_placeholder"
                        id="last_name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group mb-4">
                  <label class="form-label" for="email">{{pageContent.form_email}}</label>
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    :placeholder="form_email_placeholder"
                    id="email"
                    required
                  />
                </div>
                <div class="mb-sm-4 mb-3 position-relative">
                  <label class="form-label" for="password"
                    >{{pageContent.form_contact}}</label
                  >
                  <input
                    type="text"
                    v-model="contactNumber"
                    id="contact_number"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group mb-4">
                  <label class="form-label">Country</label>
                  <select
                    v-model="selectedCountry"
                    @change="fetchCities"
                    class="form-control"
                  >
                    <option value="" disabled>{{pageContent.form_country_placeholder}}</option>
                    <option
                      v-for="country in countries"
                      :key="country.name"
                      :value="country.name"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                </div>
                <div class="text-center">
                  <p v-if="errorMessage" class="text-danger">
                    {{ errorMessage }}
                  </p>
                  <button
                    type="submit"
                    class="btn btn-secondary btn-block mb-2 w-100"
                  >
                    Subscribe now
                  </button>
                  <br />
                  <small class="mt-2 text-center">
                    {{pageContent.form_note}}
                  </small>
                </div>
              </form>
            </div>
            <div
              class="signup-image m-0 d-flex flex-column justify-content-center align-items-center"
            >
              <figure>
                <img
                  src="/assets/images/home-banner/470691537_3778467092371094_2360789783421571428_n.png"
                  alt="sign up image"
                  class="img-fluid"
                />
              </figure>
              <a href="#" class="signup-image-link text-center mt-3">
                {{pageContent.signup_link}}
              </a>
              <p class="text-center fs-5 fw-semibold mt-2">{{pageContent.follow_us}}</p>
              <div class="d-flex justify-content-center gap-4">
                <a
                  href="https://www.facebook.com/explore2teach"
                  target="_blank"
                  class="text-blue fs-1"
                >
                  <i class="fa-brands fa-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/explore2teach/"
                  target="_blank"
                  class="text-danger fs-1"
                >
                  <i class="fa-brands fa-instagram"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/explore2teach"
                  target="_blank"
                  class="text-blue fs-1"
                >
                  <i class="fa-brands fa-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
   
  
  
  <script>
import { createUserWithEmailAndPassword } from "firebase/auth";
import TeacherResources from "@/components/TeacherResources.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, firestore } from "./../firebase";
import { mapActions } from "vuex";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "HomeView",
  components: {
    TeacherResources,
    FooterComponent,
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      contactNumber: "",
      errorMessage: "",
      selectedCountry: "United States", // Default country
      countries: ["United States", "Philippines"],
      pageContent: [],
      pageHeader:[],
      pageFooter:[],
    };
  },
  mounted() {
    this.fetchCountries();
    // this.subscribe()
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      this.language = storedLanguage;
    }
    this.convertLanguage();
  },
  methods: {
    ...mapActions(["setUser"]),
    async fetchCountries() {
      try {
        const response = await this.$axios.get(
          "https://restcountries.com/v3.1/all"
        );
        this.countries = response.data.map((country) => ({
          name: country.name.common,
          code: country.cca2, // 2-letter country code
        }));
        this.countries.sort((a, b) => a.name.localeCompare(b.name));
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    },
    async subscribeUser() {
      try {
        if (
          !this.contactNumber ||
          !this.firstName ||
          !this.lastName ||
          !this.email
        ) {
          throw new Error("All fields are required");
        }

        const userData = {
          firstName: this.firstName.trim(),
          lastName: this.lastName.trim(),
          contactNumber: this.contactNumber.trim(),
          country: this.selectedCountry,
          email: this.email.trim(),
          createdAt: serverTimestamp(),
        };

        // Save user data to Firestore
        await setDoc(
          doc(firestore, "subscribers", this.email.trim()),
          userData
        );
        await this.subscribe();
        this.$swal(
          "You are now successfully subscribed to Explore2Teach! You will get our latest news and updates."
        );

        this.resetFields();

        //this.$router.push("/dashboard");
      } catch (error) {
        console.error("Subscription error:", error);
        this.errorMessage = error.message;
      }
    },
    scrollToSubscription() {
      this.$refs.subscriptionSection.scrollIntoView({ behavior: "smooth" });
    },
    async subscribe() {
      try {
        const response = await this.$axios.post(
          "https://newsubscriber2-ujliha62qa-uc.a.run.app",
          {
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            contactNumber: this.contactNumber,
            country: this.selectedCountry,
          }
        );

        this.console.log("Successfully subscribed:", response.data);
      } catch (error) {
        // Check if error has response object
        const errorMessage = error.response
          ? error.response.data
          : error.message;
        console.error("Error subscribing:", errorMessage);
      }
    },
    resetFields() {
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.contactNumber = "";
      this.errorMessage = "";
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 80; // Adjust this value based on your header height
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === 'us') {
        lang = 'en';
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.subscribe[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };
      
        this.pageHeader={
          ...this.pageHeader,
          ...pageHeader,
        }
        this.pageFooter={
          ...this.pageFooter,
          ...pageFooter,
        }
        
      }  
    },
  },
};
</script>
  <style>
.text-shadow {
  text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 12px;
}
.video-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Dark overlay with 50% opacity */
  z-index: 1;
}
.video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh; /* Restrict video to full viewport height */
  z-index: 0; /* Change from -1 to 0 */
}

.video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.jumbotron-container {
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.jumbotron {
  color: white;
  padding: 2rem;
  border-radius: 10px;
}

.page-content {
  position: relative;
  z-index: 2;
  background: white;
  padding: 2rem;
}

display-flex,
.display-flex,
.display-flex-center,
.signup-content,
.signin-content,
.social-login,
.socials {
  display: flex;
  display: -webkit-flex;
}

/* @extend list-type-ulli; */
list-type-ulli,
.socials {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
a:focus,
a:active {
  text-decoration: none;
  outline: none;
  transition: all 300ms ease 0s;
  -moz-transition: all 300ms ease 0s;
  -webkit-transition: all 300ms ease 0s;
  -o-transition: all 300ms ease 0s;
  -ms-transition: all 300ms ease 0s;
}

img {
  max-width: 100%;
  height: auto;
}

figure {
  margin: 0;
}

p {
  margin-bottom: 0px;
  font-size: 15px;
  color: #777;
}

h2 {
  line-height: 1.66;
  margin: 0;
  padding: 0;
  font-weight: bold;
  color: #222;
  font-family: Poppins;
  font-size: 36px;
}

.main {
  background: #f8f8f8;
  padding: 10px 0;
}

.clear {
  clear: both;
}

body {
  font-size: 13px;
  line-height: 1.8;
  color: #222;
  background: #f8f8f8;
  font-weight: 400;
  font-family: Poppins;
}

.display-flex {
  justify-content: space-between;
  -moz-justify-content: space-between;
  -webkit-justify-content: space-between;
  -o-justify-content: space-between;
  -ms-justify-content: space-between;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
}

.display-flex-center {
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
}

.position-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.signup {
  margin-bottom: 150px;
}

.signup-content {
  padding: 75px 0;
}

.signup-form,
.signup-image,
.signin-form,
.signin-image {
  width: 50%;
  overflow: hidden;
}

.signup-image {
  margin: 0 55px;
}

.form-title {
  margin-bottom: 33px;
}

.signup-image {
  margin-top: 45px;
}

figure {
  margin-bottom: 10px;
  text-align: center;
}

.form-submit {
  display: inline-block;
  background: #6dabe4;
  color: #fff;
  border-bottom: none;
  width: 100%;
  padding: 15px 39px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  -o-border-radius: 5px;
  -ms-border-radius: 5px;
  margin-top: 25px;
  cursor: pointer;
}
.form-submit:hover {
  background: #4292dc;
}

#signin {
  margin-top: 16px;
}

.signup-image-link {
  font-size: 14px;
  color: #222;
  display: block;
  text-align: center;
}

.term-service {
  font-size: 13px;
  color: #222;
}

.signup-form {
  margin-left: 75px;
  margin-right: 75px;
  padding-left: 34px;
}

.register-form {
  width: 100%;
}

.agree-term {
  display: inline-block;
  width: auto;
}

.label-has-error {
  top: 22%;
}

/* label.error {
    position: relative;
    background: url("../images/unchecked.gif") no-repeat;
    background-position-y: 3px;
    padding-left: 20px;
    display: block;
    margin-top: 20px;
  } */

.label-agree-term {
  position: relative;
  top: 0%;
  transform: translateY(0);
  -moz-transform: translateY(0);
  -webkit-transform: translateY(0);
  -o-transform: translateY(0);
  -ms-transform: translateY(0);
}

.material-icons-name {
  font-size: 18px;
}

.signin-content {
  padding-top: 67px;
  padding-bottom: 87px;
}

.social-login {
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
  margin-top: 80px;
}

.social-label {
  display: inline-block;
  margin-right: 15px;
}

.socials li {
  padding: 5px;
}
.socials li:last-child {
  margin-right: 0px;
}
.socials li a {
  text-decoration: none;
}
.socials li a i {
  width: 30px;
  height: 30px;
  color: #fff;
  font-size: 14px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  -o-border-radius: 5px;
  -ms-border-radius: 5px;
  transform: translateZ(0);
  -moz-transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -o-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.socials li:hover a i {
  -webkit-transform: scale(1.3) translateZ(0);
  transform: scale(1.3) translateZ(0);
}

.zmdi-facebook {
  background: #3b5998;
}

.zmdi-twitter {
  background: #1da0f2;
}

.zmdi-google {
  background: #e72734;
}

.signin-form {
  margin-right: 90px;
  margin-left: 80px;
}
.home_logo {
  height: 250px;
}

.signin-image {
  margin-left: 110px;
  margin-right: 20px;
  margin-top: 10px;
}
.lead {
  font-size: 1.5rem;
}

@media screen and (max-width: 768px) {
  .signup-content,
  .signin-content {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    -ms-justify-content: center;
  }
  .lead {
    font-size: 0.8rem;
  }

  .home_logo {
    height: 150px;
  }
  .signup-form {
    margin-left: 0px;
    margin-right: 0px;
    padding-left: 0px;
    /* box-sizing: border-box; */
    padding: 0 30px;
  }

  .signin-image {
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 50px;
    order: 2;
    -moz-order: 2;
    -webkit-order: 2;
    -o-order: 2;
    -ms-order: 2;
  }

  .signup-form,
  .signup-image,
  .signin-form,
  .signin-image {
    width: auto;
  }

  .social-login {
    justify-content: center;
    -moz-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    -ms-justify-content: center;
  }

  .form-button {
    text-align: center;
    width: 100%;
  }

  .signin-form {
    order: 1;
    -moz-order: 1;
    -webkit-order: 1;
    -o-order: 1;
    -ms-order: 1;
    margin-right: 0px;
    margin-left: 0px;
    padding: 0 30px;
  }

  .form-title {
    text-align: center;
  }
}
@media screen and (max-width: 400px) {
  .social-login {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }

  .social-label {
    margin-right: 0px;
    margin-bottom: 10px;
  }
}
</style>